import { render, staticRenderFns } from "./c-alarm-tags-chips.vue?vue&type=template&id=906c5542&"
import script from "./c-alarm-tags-chips.vue?vue&type=script&lang=js&"
export * from "./c-alarm-tags-chips.vue?vue&type=script&lang=js&"
import style0 from "./c-alarm-tags-chips.vue?vue&type=style&index=0&id=906c5542&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports